import { cn, colors } from "tools/ui";

const PATTERN = /^-?\d*\.?\d{0,6}$/;
const formatter = Intl.NumberFormat("en-US");

function NumericCell(props) {
  const { field, data, onChange, record, name, format, decimalPlaces } = props;

  if (!field.editable) {
    const val = getFormatValue();
    const formatted = formatter.format(val);
    return field.symbol ? `${formatted} ${field.symbol}` : formatted;
  }

  function getFormatValue() {
    let _value;
    if (data.value && data.value !== "") {
      _value = data.value.toString().replaceAll(",", "");
      _value = parseFloat(_value).toFixed(decimalPlaces || 0);
      if (format && format === "percent" && record.id > 0) {
        _value = _value * 100;
      }
      _value = _value.toString();
    } else {
      _value = 0;
    }
    return _value;
  }

  function handleChange(event) {
    let _value = event.target.value;
    _value = _value.replaceAll(",", "");
    const validNumber = PATTERN.test(_value);

    if (!validNumber) {
      return;
    }

    data.value = _value;
    onChange(field, data.value, record);
  }

  function handleBlur(e) {
    const _value = getFormatValue();
    data.value = _value;
    record[field.name] = data.value;
  }

  let _color = props.readOnly ? colors.readOnly : props.color ?? "bg-white";

  return (
    <input
      id={props.name}
      name={props.name}
      className={cn(
        "h-9 rounded-md shadow-sm w-full text-right py-1 px-3 text-gray-700 border border-slate-300 focus:outline-none focus:border focus:border-cyan-500",
        _color,
      )}
      type="text"
      inputMode="numeric"
      value={formatter.format(data.value)}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={props.readOnly}
      onClick={(e) => {
        e.stopPropagation();
      }}
    />
  );
}

export default NumericCell;
